var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M9.732 7.5h5.5L9.732 2v5.5zm-7-7h8l6 6v12a2 2 0 0 1-2 2h-12a2 2 0 0 1-2-2v-16c0-1.11.89-2 2-2zm9 16v-2h-9v2h9zm3-4v-2h-12v2h12z" })
  );
});


// WEBPACK FOOTER //
// ./src/static/images/icons/feedbacks.svg